import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class StationsService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'meteo-stations';

  list(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  get(id): Observable<Station> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/id/' + id;
    const headers = new HttpHeaders()
    // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<Station>(uri, {headers: headers});
  }

  isExistStation(id): Observable<Station[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/exist/' + id;
    const headers = new HttpHeaders()
    // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<Station[]>(uri, {headers: headers});
  }

  getGeocity(id): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/city/' + id;
    const headers = new HttpHeaders()
    // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getICAO(id): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/icao/' + id;
    const headers = new HttpHeaders()
    // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getNear(id): Observable<any[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/near/' + id;
    const headers = new HttpHeaders()
    // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any[]>(uri, {headers: headers});
  }
}

interface Station {
  published: number,
  station_id: number,
  region: string,
  tags: string,
  height: number | string,
  title: string,
  text: string,
}